<template>
  <div id="register-role">
    <div class="logo-wrapper">
      <div class="login-content-wrapper">
        <div class="logo" @click="toHomePage(platForm.link)">
          <span class="logo-img">
            <img
              v-if="platForm.logoImg"
              :alt="platForm.alt"
              :src="require(`@/assets${platForm.logoImg}`)"
            />
          </span>
          <div v-if="platForm.showName" class="logo-text">
            <span class="platformName">{{ platForm.platformName }}</span>
            <span>{{ platForm.alt }}</span>
          </div>
          <span class="logo-font">欢迎注册</span>
        </div>
        <span class="login-text">
          已有账号，
          <a href="javascript:;" @click="goLogin">立即登录</a>
        </span>
        <a
          class="return-role-btn"
          href="javascript:void(0);"
          v-if="showRegister"
          @click="showRegister = false"
          ><a-icon type="left" class="return-icon" />返回角色选择</a
        >
        <!-- <div class="role-item">
          <img :src="require('../images/supplier.svg')" alt="供应商">
          <h2>供应商</h2>
        </div> -->
        <!-- <div class="content-container">
          <h2>是指参与云采链平台项目竞价、竞拍或调研的平台用户</h2>
          <h3>入驻流程：填写下方注册信息并点击【下一步】→按提示登录账号→完善公司详细信息并提交认证。如需申请入库专属子平台，请在认证成功后，在【未入库平台】处提交申请。只需注册一次即为云采链供应商，勿需重复注册。</h3>
          <h3>入驻审核：请供应商按申请页面的要求上传相应的资质文件并提交申请，由审核机构进行审核，审核结果将会以短信息的方式通知供应商。</h3>
        </div> -->
      </div>
    </div>
    <div class="select-warpper" v-if="!showRegister">
      <div class="content-wrapper">
        <h2 style="text-align: center; margin: 70px 0 60px; font-size: 20px">
          请选择注册角色
        </h2>
        <div class="role-select">
          <div
            class="role-item"
            @click="selectRole(role)"
            v-for="role in roles"
            :key="role.title"
          >
            <img :src="role.img" :alt="role.title" />
            <div class="item-details">
              <p>{{ role.title }}</p>
              <p class>{{ role.explain }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <component
      v-else
      :is="currentRole"
      :registerRole="registerRole"
    ></component>
  </div>
</template>

<script>
import normalRegister from "./components/normalRegister";
import supplierRegistration from "./components/supplierRegistration";
import { mapActions } from "vuex";
import { getPlatFormlogoImageMap } from "@/config/dict";

const roles = [
  {
    title: "采购人",
    explain: "我要招标",
    img: require("./images/bidder.svg"),
    routeName: "normalRegister",
  },
  {
    title: "供应商",
    explain: "我要投标",
    img: require("./images/supplier.svg"),
    // routeName: 'normalRegister'
    routeName: "supplierRegistration",
  },
  // {
  //   title: '代理机构',
  //   explain: '我要提供招标代理服务',
  //   img: require('./images/dljg.svg'),
  //   routeName: 'normalRegister'
  // }
  // ,
  // {
  //   title: '专家',
  //   explain: '我要参与项目评审',
  //   img: require('./images/expert.svg'),
  //   routeName: 'expertRegister'
  // }
];

export default {
  name: "RegisterRole",
  components: {
    normalRegister,
    supplierRegistration,
    // expertRegister
  },
  data() {
    return {
      currentRole: "Registration",
      registerRole: "采购人",
      roles,
      showRegister: false,
      platForm: null,
    };
  },
  mounted() {
    // 查询是否已登录 自动退出
    if (this.$ls.get("ACCESS_TOKEN")) {
      this.Logout({}).then(() => {
        window.location.reload();
      });
    }
  },
  computed: {
    queryTenantID() {
      return this.$route?.query?.tenantId || "";
    },
  },
  watch: {
    queryTenantID: {
      async handler(val) {
        if (val) {
          this.platForm = await getPlatFormlogoImageMap(val);
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["Logout"]),
    selectRole(role) {
      if (!role.routeName) {
        this.$message.info("暂未开放此角色注册，敬请期待");
        return;
      }
      this.currentRole = role.routeName;
      this.registerRole = role.title;
      this.showRegister = true;
    },
    goLogin() {
      if (this.$route.query.tenantId && this.platForm) {
        this.$router.push({
          path: "/login",
          query: { tenantId: this.$route.query.tenantId },
        });
      } else {
        this.$router.push({ path: "/login" });
      }
    },
    toHomePage(link) {
      if (link) {
        location.href = link;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-wrapper {
  width: 1200px;
  min-height: 800px;
  background: #fff;
  margin: 0 auto;
  padding: 50px 0;
  box-shadow: 0 2px 15px 0 rgba(190, 207, 228, 0.3);
}
#register-role {
  .logo-wrapper {
    line-height: 120px;
    background-color: #fff;
    box-shadow: 0px 2px 15px 0px rgba(190, 207, 228, 0.3);

    .login-content-wrapper {
      margin: 0 auto;
      width: 1230px;
      position: relative;
      .logo {
        display: flex;
        flex-direction: row;
        cursor: pointer;
        .logo-text {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 20px;
          font-size: 18px;
          line-height: 28px;
          font-weight: 600;
          .platformName {
            font-size: 25px;
            margin-bottom: 5px;
          }
        }
        .logo-img {
          height: 50px;
        }
        .logo-img > img {
          // width: 200px;
          height: 70px;
        }
      }
      .login-text {
        position: absolute;
        right: 0;
        bottom: 20px;
        font-size: 14px;
        line-height: 14px;
      }
      .return-role-btn {
        position: absolute;
        top: 135px;
        left: 16px;
        line-height: 16px;
        z-index: 500;
        color: #1890ff;
        font-size: 16px;
        .return-icon {
          margin-right: 8px;
        }
      }
    }
  }
  .select-warpper {
    padding: 40px 0;
    background: #f7f7f8;

    .role-select {
      display: flex;
      flex-direction: row;
      justify-content: center;

      .role-item {
        width: 200px;
        height: 262px;
        background: #fff;
        flex: 0 0 auto;
        margin: 0 20px;
        box-shadow: 0px 2px 10px 0px rgba(227, 236, 250, 1);
        &:nth-child(1) {
          border-top: 7px solid #95b5ff;
        }
        &:nth-child(2) {
          border-top: 7px solid #ff956d;
        }
        &:nth-child(3) {
          border-top: 7px solid #ffd374;
        }
        &:nth-child(4) {
          border-top: 7px solid #6caefb;
        }
        &:hover {
          cursor: pointer;
          transform: translate(0px, -5px);
          transition: 0.3s;
        }
        .item-details {
          text-align: center;
          font-size: 20px;
          margin-top: -35px;
          p {
            margin-bottom: 5px;
            &:nth-child(2) {
              color: #999999;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .logo-font {
    padding-left: 20px;
    font-size: 30px;
    color: #2c3e50;
    vertical-align: middle;
  }
}
</style>
